import { Card, Accordion } from "react-bootstrap";
import { getTimeRange } from "../../../../utils/timeFormatter";

const TrainingDates = ({ batch, type, batchStudents, defaultAccordion }) => {
    const hasSession = (session) =>
        session?.from !== null || session?.to !== null;
    return (
        <>
            <Card>
                <Card.Body>
                    <Card.Title tag="h5">Training dates</Card.Title>

                    {batch?.training_dates && (
                        <Accordion defaultActiveKey={defaultAccordion} flush>
                            {batch?.training_dates.map(
                                (training_date, accordionIndex) => {
                                    return (
                                        <Accordion.Item
                                            eventKey={`trainingAccordion-${accordionIndex}`}
                                            key={`trainingdate-${accordionIndex}`}
                                            className="bg-white"
                                        >
                                            <Accordion.Header>
                                                {accordionIndex + 1}.{" "}
                                                {training_date.date}
                                                {getTimeRange(training_date)}
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <ul className="list-unstyled mb-0 mt-2">
                                                    <li className="mb-2">
                                                        {" "}
                                                        {training_date.time}
                                                    </li>
                                                    <li className="mb-2">
                                                        Trainer{" "}
                                                        {accordionIndex + 1}
                                                    </li>
                                                    <li className="mb-2">
                                                        {
                                                            training_date?.training_type
                                                        }
                                                    </li>
                                                </ul>

                                                <table className="table table-bordered text-center">
                                                    <tbody>
                                                        <tr>
                                                            {hasSession(
                                                                training_date?.am
                                                            ) &&
                                                                type?.toLowerCase() ===
                                                                    "attendance" && (
                                                                    <td
                                                                        className="bg-secondary text-light"
                                                                        style={{
                                                                            cursor: "pointer",
                                                                        }}
                                                                        onClick={() =>
                                                                            batchStudents(
                                                                                "AM",
                                                                                training_date.date,
                                                                                `trainingAccordion-${accordionIndex}`
                                                                            )
                                                                        }
                                                                    >
                                                                        AM
                                                                    </td>
                                                                )}
                                                            {hasSession(
                                                                training_date?.pm
                                                            ) &&
                                                                type?.toLowerCase() ===
                                                                    "attendance" && (
                                                                    // <td
                                                                    //     className="bg-secondary text-light"
                                                                    //     style={{
                                                                    //         cursor: "pointer",
                                                                    //     }}
                                                                    //     onClick={() =>
                                                                    //         batchStudents(
                                                                    //             "PM",
                                                                    //             training_date.date,
                                                                    //             `trainingAccordion-${accordionIndex}`
                                                                    //         )
                                                                    //     }
                                                                    // >
                                                                    //     PM
                                                                    // </td>
                                                                    <td>
                                                                        PM
                                                                    </td>
                                                                )}
                                                            {hasSession(
                                                                training_date?.ev
                                                            ) &&
                                                                type?.toLowerCase() ===
                                                                    "attendance" && (
                                                                    <td
                                                                        className="bg-secondary text-light"
                                                                        style={{
                                                                            cursor: "pointer",
                                                                        }}
                                                                        onClick={() =>
                                                                            batchStudents(
                                                                                "EV",
                                                                                training_date.date,
                                                                                `trainingAccordion-${accordionIndex}`
                                                                            )
                                                                        }
                                                                    >
                                                                        EV
                                                                    </td>
                                                                )}
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    );
                                }
                            )}
                        </Accordion>
                    )}
                </Card.Body>

                <hr className="my-0" />
                <Card.Body>
                    <Card.Title tag="h5">Invigilators</Card.Title>
                    {batch?.invigilators && (
                        <ul className="list-unstyled mb-0">
                            {batch?.invigilators.map((invigilator, index) => {
                                return (
                                    <li
                                        key={`invigilators-${index}`}
                                        className="pb-2"
                                    >
                                        <div className="d-flex justify-content-start">
                                            <div>{index + 1}</div>{" "}
                                            <div className="m-1"></div>
                                            <div>{invigilator?.name}</div>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </Card.Body>
            </Card>
        </>
    );
};
export default TrainingDates;
